const state = {
    type: null,
    message: null
};

const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    }
};

const mutations = {
    success(state, message) {
        state.type = 'bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative';
        state.message = message;
    },
    error(state, message) {
        state.type = 'bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
}